import Cookie from 'cookie-universal';
import {
  CHANGE_THEME_TO_DARK,
  CHANGE_THEME_TO_LIGHT,
} from '../actions/themeActions';

const cookies = Cookie();

const initialState = {
  className: cookies.get('theme') || 'theme-light',
};

// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case CHANGE_THEME_TO_DARK:
      cookies.set('theme', 'theme-dark');
      return { className: 'theme-dark' };
    case CHANGE_THEME_TO_LIGHT:
      cookies.set('theme', 'theme-light');
      return { className: 'theme-light' };
    default:
      return state;
  }
}
